<h5 class="mobile-nav-title" i18n>Leads</h5>
<div class="container-fluid">
  <button type="button" routerLink="/lead/add" class="btn btn-bidit-submit mb-2" i18n>Add Lead</button>
  <form class="row" (ngSubmit)="loadLeads()">
    <div class="col-sm-3">
      <input name="projectName" id="projectName" class="form-control"
             placeholder="Search Projects" i18n-placeholder
             [(ngModel)]="filter.projectName" #projectName="ngModel" />
    </div>
    <div class="col-sm-3">
      <select name="dateRange" id="dateRange"
              class="form-control select-bidit"
              [(ngModel)]="filter.dateRange" #dateRange="ngModel">
        <option value="null" i18n>Select Expiration Date Range</option>
        <option value="1" i18n>Current Month</option>
        <option value="2" i18n>Current Quarter</option>
        <option value="3" i18n>Current Year</option>
        <option value="4" i18n>Prior Month</option>
        <option value="5" i18n>Prior Quarter</option>
        <option value="6" i18n>Prior Year</option>
      </select>
    </div>
    <div class="col-sm-3">
      <select name="jobTypeId" id="jobTypeId"
              class="form-control select-bidit"
              [(ngModel)]="filter.jobTypeId" #jobTypeId="ngModel">
        <option value="null" i18n>Select Job Type</option>
        <option *ngFor="let jobType of summary?.jobTypes" [ngValue]="jobType.jobType_ID">{{jobType.jobType_Desc}}</option>
      </select>
    </div>
    <div class="col-sm-3">
      <select name="probability" id="probability"
              class="form-control select-bidit"
              [(ngModel)]="filter.probability" #probability="ngModel">
        <option value="" i18n>Select Probability</option>
        <option value="H" i18n>High</option>
        <option value="M" i18n>Medium</option>
        <option value="L" i18n>Low</option>
      </select>
      <select name="salespersonId" id="salespersonId"
              class="form-control select-bidit"
              [(ngModel)]="filter.salespersonId" #salespersonId="ngModel">
        <option value="" i18n>Select Salesperson</option>
        <option *ngFor="let salesperson of summary?.salespersons" [ngValue]="salesperson.id">{{salesperson.lastName}}, {{salesperson.firstName}}</option>
      </select>
    </div>
    <div class="col form-inline">
      <div class="col form-inline">
        <label for="allLeads" class="mt-2  text-bidit-primary" i18n>All Leads</label>
        <input id="pastDue" name="pastDue"
               type="checkbox" class="bidit-switch-sm m-2"
               [(ngModel)]="filter.pastDue" #pastDue="ngModel" />
        <label for="pastDue" class="mt-2 text-bidit-primary" i18n>Past Due</label>
      </div>
      <div class="float-right">
        <button type="submit" class="text-white btn btn-bidit-navigate" i18n>Apply Filter</button>
      </div>
    </div>
  </form>
  <h5 class="col mb-3" i18n>Leads</h5>
  <div
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        (scrolled)="onScroll()">
    <div *ngFor="let lead of leads">
      <div class="card border-bidit-dark bg-light mb-3 shadow">
        <div class="card-body">
          <div class="col">
            <a class="mobile-link" routerLink="/lead/{{lead.quote_ID}}">
              {{lead.quote_Name}} #{{lead.quote_ProjectNumber}}
            </a>
          </div>
          <div class="col">
            <div class="row">
              <div class="col-6">
                <span class="form-inline">
                  <span class="text-bidit-primary">{{lead.customer?.customer_BusinessName}}</span>
                </span>
                <div class="form-inline">
                  <span class="text-bidit-primary">{{lead.jobType?.jobType_Desc}}</span>
                </div>
                <div class="form-inline">
                  <label for="probability" class="text-bidit-primary" i18n>Probability:</label>
                  <span id="probability" class="text-bidit-primary">{{lead.quote_Probability | convertProbability}}</span>
                </div>
              </div>
              <div class="col-6">
                <div class="form-inline">
                  <label for="mainContactMobile" class="text-bidit-primary" i18n>Start Date:</label>
                  <a id="mainContactMobile" class="text-bidit-primary">{{lead.quote_ReadyDate | date: 'M/d/yyyy'}}</a>
                </div>
                <div class="">
                  <label for="mainContactMobile" class="text-bidit-primary" i18n>Expiration Date:</label>
                  <a class="text-bidit-primary">{{lead.quote_LeadDueDate | date: 'M/d/yyyy'}}</a>
                </div>
                <div class="form-inline">
                  <label for="mainContactMobile" class="text-bidit-primary" i18n>Salesperson:</label>
                    <div *ngFor="let quoteAssignment of lead.quoteAssignments" class="text-bidit-primary">
                      {{quoteAssignment.assignedTo.firstName}} {{quoteAssignment.assignedTo.lastName}}
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
